module.exports = __webpack_public_path__ + "img/pragmaticlive.27cfa733.svg";